module.exports = __webpack_public_path__ + "static/media/IMG-1.43468d66.jpg";